import { add, forIn } from "lodash";

export default class Navigation {
    constructor() {
        this.mainMenu = document.querySelector('ul#main-menu');

        if (this.mainMenu) {
            this.addListeners();
            this.customMobileMenuAdditions();
        }
    }

    addListeners() {
        this.mainMenu.querySelectorAll('li.menu-item-has-children').forEach((el) => {
            el.querySelector(":scope > a").addEventListener('click', event => {
                this.toggleMenu(event, el);
            });
            el.querySelector(":scope > a").addEventListener('touchstart', event => {
                this.toggleMenu(event, el);
            });
            el.querySelector(":scope > a").addEventListener('keydown', event => {
                this.toggleMenu(event, el);
            });
        });
    }

    customMobileMenuAdditions() {
        let mobileAdditions = document.querySelectorAll(".mobile-addition");

        if (mobileAdditions.length > 0) {
            for (const additions of mobileAdditions) {
                this.mainMenu.appendChild(additions.cloneNode(true));
            }
        }
    }

    toggleMenu(event, el) {
        // Only trigger on enter or space
        if (event.type === 'keydown' && event.keyCode !== 13 && event.keyCode !== 32) {
            return;
        }

        event.preventDefault();

        let submenus = el.querySelector('.sub-menu');

        if (submenus) {
            el.classList.toggle('show');
            submenus.classList.toggle('show');
        }
    }
}
